import { useRef, useEffect, useState, useCallback } from "react";

// ---------- Pixel sprites (1 = lit pixel) ----------
const INVADER_A = [
  [0,0,1,0,0,0,0,0,1,0,0],
  [0,0,0,1,0,0,0,1,0,0,0],
  [0,0,1,1,1,1,1,1,1,0,0],
  [0,1,1,0,1,1,1,0,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1],
  [1,0,1,1,1,1,1,1,1,0,1],
  [1,0,1,0,0,0,0,0,1,0,1],
  [0,0,0,1,1,0,1,1,0,0,0],
];
const INVADER_A2 = [
  [0,0,1,0,0,0,0,0,1,0,0],
  [1,0,0,1,0,0,0,1,0,0,1],
  [1,0,1,1,1,1,1,1,1,0,1],
  [1,1,1,0,1,1,1,0,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1],
  [0,1,1,1,1,1,1,1,1,1,0],
  [0,0,1,0,0,0,0,0,1,0,0],
  [0,1,0,0,0,0,0,0,0,1,0],
];
const INVADER_B = [
  [0,0,0,1,1,1,1,0,0,0],
  [0,1,1,1,1,1,1,1,1,0],
  [1,1,1,1,1,1,1,1,1,1],
  [1,1,1,0,0,0,0,1,1,1],
  [1,1,1,1,1,1,1,1,1,1],
  [0,0,1,1,0,0,1,1,0,0],
  [0,1,1,0,1,1,0,1,1,0],
  [1,1,0,0,0,0,0,0,1,1],
];
const INVADER_B2 = [
  [0,0,0,1,1,1,1,0,0,0],
  [0,1,1,1,1,1,1,1,1,0],
  [1,1,1,1,1,1,1,1,1,1],
  [1,1,1,0,0,0,0,1,1,1],
  [1,1,1,1,1,1,1,1,1,1],
  [0,1,1,0,1,1,0,1,1,0],
  [1,1,0,1,0,0,1,0,1,1],
  [0,0,1,1,0,0,1,1,0,0],
];
const UFO = [
  [0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0],
  [0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0],
  [0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0],
  [0,1,1,0,1,1,0,1,1,0,1,1,0,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [0,0,1,1,1,0,0,1,1,0,0,1,1,1,0,0],
  [0,0,0,1,0,0,0,0,0,0,0,0,1,0,0,0],
];
const SHIP = [
  [0,0,0,0,0,1,0,0,0,0,0],
  [0,0,0,0,1,1,1,0,0,0,0],
  [0,0,0,0,1,1,1,0,0,0,0],
  [0,1,1,1,1,1,1,1,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1],
];

function drawSprite(ctx, sprite, x, y, px, color) {
  ctx.fillStyle = color;
  for (let r = 0; r < sprite.length; r++) {
    for (let c = 0; c < sprite[r].length; c++) {
      if (sprite[r][c]) ctx.fillRect(x + c * px, y + r * px, px, px);
    }
  }
}

// ---------- Bunkers ----------
const BUNKER_SHAPE = [
  [0,0,1,1,1,1,1,1,1,1,1,1,0,0],
  [0,1,1,1,1,1,1,1,1,1,1,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,0,0,0,0,0,0,1,1,1,1],
  [1,1,1,0,0,0,0,0,0,0,0,1,1,1],
  [1,1,1,0,0,0,0,0,0,0,0,1,1,1],
];
const BUNKER_PX = 5;

function erodeBunker(bunker, cx, cy) {
  // knock out a rough blob of cells around the impact point
  for (let r = 0; r < bunker.cells.length; r++) {
    for (let c = 0; c < bunker.cells[r].length; c++) {
      if (!bunker.cells[r][c]) continue;
      const d = Math.hypot(c - cx, r - cy);
      if (d < 1.6 || (d < 2.8 && Math.random() < 0.55)) bunker.cells[r][c] = 0;
    }
  }
}

function bunkerHit(g, x, y, prevY) {
  // returns true if the projectile hit a bunker cell (checks a few points along its path)
  for (const bk of g.bunkers) {
    const w = bk.cells[0].length * BUNKER_PX, h = bk.cells.length * BUNKER_PX;
    if (x < bk.x || x >= bk.x + w) continue;
    const steps = 3;
    for (let s = 0; s <= steps; s++) {
      const sy = prevY + ((y - prevY) * s) / steps;
      if (sy < bk.y || sy >= bk.y + h) continue;
      const c = Math.floor((x - bk.x) / BUNKER_PX);
      const r = Math.floor((sy - bk.y) / BUNKER_PX);
      if (bk.cells[r] && bk.cells[r][c]) {
        erodeBunker(bk, c, r);
        return true;
      }
    }
  }
  return false;
}

// ---------- Tiny WebAudio blips ----------
function makeAudio() {
  let ctx = null;
  const ensure = () => {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
  };
  const blip = (freq, dur, type = "square", vol = 0.05) => {
    try {
      const ac = ensure();
      const o = ac.createOscillator();
      const g = ac.createGain();
      o.type = type;
      o.frequency.value = freq;
      g.gain.setValueAtTime(vol, ac.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + dur);
      o.connect(g).connect(ac.destination);
      o.start();
      o.stop(ac.currentTime + dur);
    } catch (e) { /* audio unavailable */ }
  };
  return {
    shoot: () => blip(880, 0.08),
    hit: () => blip(180, 0.15, "sawtooth", 0.07),
    playerHit: () => blip(90, 0.4, "sawtooth", 0.09),
    step: (n) => blip([120, 100, 90, 80][n % 4], 0.06, "square", 0.03),
    wave: () => { blip(440, 0.1); setTimeout(() => blip(660, 0.1), 110); setTimeout(() => blip(880, 0.15), 220); },
    ufoBlip: () => { blip(620, 0.07, "triangle", 0.04); },
    ufoHit: () => { blip(1200, 0.1); setTimeout(() => blip(900, 0.1), 100); setTimeout(() => blip(1400, 0.2), 200); },
  };
}

export default function SpaceInvaders() {
  const canvasRef = useRef(null);
  const wrapRef = useRef(null);
  const [screen, setScreen] = useState("start"); // start | play | over
  const [hud, setHud] = useState({ score: 0, lives: 3, wave: 1, hi: 0 });
  const game = useRef(null);
  const audio = useRef(null);
  const screenRef = useRef("start");
  screenRef.current = screen;

  const newGame = useCallback((w, h) => ({
    W: w, H: h,
    ship: { x: w / 2, y: h - 46, w: 44, h: 24, targetX: w / 2 },
    bullets: [],
    bombs: [],
    invaders: [],
    particles: [],
    dir: 1,
    speed: 22,           // px/sec horizontal march
    dropPending: false,
    fireCooldown: 0,
    stepTimer: 0,
    stepNote: 0,
    score: 0,
    lives: 3,
    wave: 1,
    hi: Number((typeof window !== "undefined" && window.__si_hi) || 0),
    invulnerable: 0,
    flash: 0,
    ufo: null,
    ufoTimer: 8 + Math.random() * 8,
    ufoBlipTimer: 0,
    popups: [],
    bunkers: [],
  }), []);

  const spawnWave = (g) => {
    g.invaders = [];
    const cols = 7, rows = 4;
    const cellW = Math.min(46, (g.W - 40) / cols);
    const startX = (g.W - cols * cellW) / 2 + cellW / 2;
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        g.invaders.push({
          x: startX + c * cellW,
          y: 90 + r * 44,
          type: r < 2 ? "A" : "B",
          alive: true,
          w: 30, h: 22,
        });
      }
    }
    g.dir = 1;
    g.speed = 20 + (g.wave - 1) * 8;
    g.bombs = [];
    // fresh bunkers each wave
    g.bunkers = [];
    const count = g.W < 380 ? 3 : 4;
    const bw = BUNKER_SHAPE[0].length * BUNKER_PX;
    const gap = (g.W - count * bw) / (count + 1);
    for (let i = 0; i < count; i++) {
      g.bunkers.push({
        x: gap + i * (bw + gap),
        y: g.H - 140,
        cells: BUNKER_SHAPE.map(row => [...row]),
      });
    }
  };

  const start = useCallback(() => {
    const cvs = canvasRef.current;
    if (!cvs) return;
    if (!audio.current) audio.current = makeAudio();
    const g = newGame(cvs.width / (window.devicePixelRatio || 1), cvs.height / (window.devicePixelRatio || 1));
    spawnWave(g);
    game.current = g;
    setHud({ score: 0, lives: 3, wave: 1, hi: g.hi });
    setScreen("play");
  }, [newGame]);

  // ---------- Input ----------
  useEffect(() => {
    const cvs = canvasRef.current;
    if (!cvs) return;

    const moveTo = (clientX) => {
      const g = game.current;
      if (!g) return;
      const rect = cvs.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * g.W;
      g.ship.targetX = Math.max(26, Math.min(g.W - 26, x));
    };
    const onTouch = (e) => {
      if (screenRef.current !== "play") return;
      e.preventDefault();
      moveTo(e.touches[0].clientX);
    };
    const onMouse = (e) => {
      if (screenRef.current !== "play") return;
      if (e.buttons || e.type === "mousemove") moveTo(e.clientX);
    };
    const keys = {};
    const onKey = (e) => { keys[e.key] = e.type === "keydown"; game.current && (game.current.keys = keys); };

    cvs.addEventListener("touchstart", onTouch, { passive: false });
    cvs.addEventListener("touchmove", onTouch, { passive: false });
    cvs.addEventListener("mousemove", onMouse);
    window.addEventListener("keydown", onKey);
    window.addEventListener("keyup", onKey);
    return () => {
      cvs.removeEventListener("touchstart", onTouch);
      cvs.removeEventListener("touchmove", onTouch);
      cvs.removeEventListener("mousemove", onMouse);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("keyup", onKey);
    };
  }, []);

  // ---------- Sizing ----------
  useEffect(() => {
    const cvs = canvasRef.current, wrap = wrapRef.current;
    if (!cvs || !wrap) return;
    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      const w = wrap.clientWidth;
      const h = wrap.clientHeight;
      cvs.width = w * dpr;
      cvs.height = h * dpr;
      cvs.style.width = w + "px";
      cvs.style.height = h + "px";
      const ctx = cvs.getContext("2d");
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (game.current) {
        game.current.W = w;
        game.current.H = h;
        game.current.ship.y = h - 46;
        game.current.bunkers.forEach(bk => (bk.y = h - 140));
      }
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // ---------- Main loop ----------
  useEffect(() => {
    const cvs = canvasRef.current;
    if (!cvs) return;
    const ctx = cvs.getContext("2d");
    let raf, last = performance.now();

    const AMBER = "#FFB000", AMBER_DIM = "#8A5A00", AMBER_HOT = "#FFE29A", BG = "#0B0500";

    const loop = (now) => {
      raf = requestAnimationFrame(loop);
      const dt = Math.min(0.033, (now - last) / 1000);
      last = now;
      const g = game.current;
      const dpr = window.devicePixelRatio || 1;
      const W = cvs.width / dpr, H = cvs.height / dpr;

      // Background
      ctx.fillStyle = BG;
      ctx.fillRect(0, 0, W, H);
      // faint starfield
      ctx.fillStyle = "rgba(255,176,0,0.10)";
      for (let i = 0; i < 40; i++) {
        const sx = (i * 97) % W, sy = ((i * 61) + (now * 0.01 * ((i % 3) + 1))) % H;
        ctx.fillRect(sx, sy, 2, 2);
      }

      if (g && screenRef.current === "play") {
        // --- update ship
        if (g.keys) {
          if (g.keys.ArrowLeft) g.ship.targetX -= 320 * dt;
          if (g.keys.ArrowRight) g.ship.targetX += 320 * dt;
          g.ship.targetX = Math.max(26, Math.min(g.W - 26, g.ship.targetX));
        }
        g.ship.x += (g.ship.targetX - g.ship.x) * Math.min(1, dt * 14);

        // --- auto-fire
        g.fireCooldown -= dt;
        if (g.fireCooldown <= 0) {
          g.bullets.push({ x: g.ship.x, y: g.ship.y - 16 });
          g.fireCooldown = 0.38;
          audio.current && audio.current.shoot();
        }

        // --- bullets
        g.bullets.forEach(b => {
          const prevY = b.y;
          b.y -= 480 * dt;
          if (bunkerHit(g, b.x, b.y, prevY)) b.y = -100;
        });
        g.bullets = g.bullets.filter(b => b.y > -20);

        // --- invaders march
        const alive = g.invaders.filter(i => i.alive);
        const speedScale = 1 + (1 - alive.length / g.invaders.length) * 1.6;
        let minX = Infinity, maxX = -Infinity, maxY = -Infinity;
        alive.forEach(i => { minX = Math.min(minX, i.x - 16); maxX = Math.max(maxX, i.x + 16); maxY = Math.max(maxY, i.y); });
        const vx = g.dir * g.speed * speedScale * dt;
        if (maxX + vx > g.W - 12 || minX + vx < 12) {
          g.dir *= -1;
          alive.forEach(i => (i.y += 18));
        } else {
          alive.forEach(i => (i.x += vx));
        }
        // marching beat
        g.stepTimer -= dt;
        if (g.stepTimer <= 0 && alive.length) {
          audio.current && audio.current.step(g.stepNote++);
          g.stepTimer = Math.max(0.12, 0.7 / speedScale);
        }

        // --- invader bombs
        if (alive.length && Math.random() < (0.5 + g.wave * 0.15) * dt) {
          const shooter = alive[Math.floor(Math.random() * alive.length)];
          g.bombs.push({ x: shooter.x, y: shooter.y + 14 });
        }
        g.bombs.forEach(b => {
          const prevY = b.y;
          b.y += (140 + g.wave * 18) * dt;
          if (bunkerHit(g, b.x, b.y, prevY)) b.y = H + 100;
        });
        g.bombs = g.bombs.filter(b => b.y < H + 20);

        // --- invaders grind through bunkers they touch
        g.bunkers.forEach(bk => {
          const bw = bk.cells[0].length * BUNKER_PX, bh = bk.cells.length * BUNKER_PX;
          alive.forEach(i => {
            if (i.x + 16 > bk.x && i.x - 16 < bk.x + bw && i.y + 12 > bk.y && i.y - 12 < bk.y + bh) {
              const c = Math.floor((i.x - bk.x) / BUNKER_PX);
              const r = Math.floor((i.y - bk.y) / BUNKER_PX);
              erodeBunker(bk, c, r);
              erodeBunker(bk, c - 2, r);
              erodeBunker(bk, c + 2, r);
            }
          });
        });

        // --- collisions: bullets vs invaders
        g.bullets.forEach(b => {
          alive.forEach(i => {
            if (i.alive && Math.abs(b.x - i.x) < 17 && Math.abs(b.y - i.y) < 14) {
              i.alive = false;
              b.y = -100;
              g.score += i.type === "A" ? 30 : 20;
              audio.current && audio.current.hit();
              for (let p = 0; p < 10; p++) {
                g.particles.push({ x: i.x, y: i.y, vx: (Math.random() - 0.5) * 220, vy: (Math.random() - 0.5) * 220, life: 0.45 });
              }
            }
          });
        });

        // --- UFO bonus ship
        if (!g.ufo) {
          g.ufoTimer -= dt;
          if (g.ufoTimer <= 0 && alive.length) {
            const fromLeft = Math.random() < 0.5;
            g.ufo = { x: fromLeft ? -30 : g.W + 30, y: 48, dir: fromLeft ? 1 : -1 };
          }
        } else {
          g.ufo.x += g.ufo.dir * 110 * dt;
          g.ufoBlipTimer -= dt;
          if (g.ufoBlipTimer <= 0) {
            audio.current && audio.current.ufoBlip();
            g.ufoBlipTimer = 0.22;
          }
          if (g.ufo.x < -40 || g.ufo.x > g.W + 40) {
            g.ufo = null;
            g.ufoTimer = 12 + Math.random() * 10;
          }
        }
        if (g.ufo) {
          g.bullets.forEach(b => {
            if (g.ufo && Math.abs(b.x - g.ufo.x) < 26 && Math.abs(b.y - g.ufo.y) < 14) {
              const bonus = [50, 100, 150, 300][Math.floor(Math.random() * 4)];
              g.score += bonus;
              g.popups.push({ x: g.ufo.x, y: g.ufo.y, text: String(bonus), life: 1.1 });
              for (let p = 0; p < 16; p++) {
                g.particles.push({ x: g.ufo.x, y: g.ufo.y, vx: (Math.random() - 0.5) * 280, vy: (Math.random() - 0.5) * 280, life: 0.45 });
              }
              audio.current && audio.current.ufoHit();
              b.y = -100;
              g.ufo = null;
              g.ufoTimer = 12 + Math.random() * 10;
            }
          });
        }
        // score popups
        g.popups.forEach(p => { p.y -= 24 * dt; p.life -= dt; });
        g.popups = g.popups.filter(p => p.life > 0);

        // --- collisions: bombs vs ship
        g.invulnerable -= dt;
        g.bombs.forEach(b => {
          if (g.invulnerable <= 0 && Math.abs(b.x - g.ship.x) < 22 && Math.abs(b.y - g.ship.y) < 14) {
            b.y = H + 100;
            g.lives -= 1;
            g.invulnerable = 1.6;
            g.flash = 0.25;
            audio.current && audio.current.playerHit();
          }
        });

        // --- invaders reach ship line
        if (maxY > g.ship.y - 30) g.lives = 0;

        // --- particles
        g.particles.forEach(p => { p.x += p.vx * dt; p.y += p.vy * dt; p.life -= dt; });
        g.particles = g.particles.filter(p => p.life > 0);

        // --- wave clear / game over
        if (!alive.length) {
          g.wave += 1;
          spawnWave(g);
          audio.current && audio.current.wave();
        }
        if (g.lives <= 0) {
          g.hi = Math.max(g.hi, g.score);
          if (typeof window !== "undefined") window.__si_hi = g.hi;
          setHud({ score: g.score, lives: 0, wave: g.wave, hi: g.hi });
          setScreen("over");
        } else {
          setHud(h => (h.score !== g.score || h.lives !== g.lives || h.wave !== g.wave)
            ? { score: g.score, lives: g.lives, wave: g.wave, hi: g.hi } : h);
        }

        // --- draw
        const blink = Math.floor(now / 400) % 2 === 0;
        alive.forEach(i => {
          const spr = i.type === "A" ? (blink ? INVADER_A : INVADER_A2) : (blink ? INVADER_B : INVADER_B2);
          const px = 3;
          drawSprite(ctx, spr, i.x - (spr[0].length * px) / 2, i.y - (spr.length * px) / 2, px, AMBER);
        });

        // UFO
        if (g.ufo) {
          const px = 3;
          const wobble = Math.sin(now * 0.01) * 2;
          drawSprite(ctx, UFO, g.ufo.x - (UFO[0].length * px) / 2, g.ufo.y - (UFO.length * px) / 2 + wobble, px, AMBER_HOT);
        }

        // score popups
        ctx.font = "bold 14px 'Courier New', monospace";
        ctx.textAlign = "center";
        g.popups.forEach(p => {
          ctx.globalAlpha = Math.max(0, p.life / 1.1);
          ctx.fillStyle = AMBER_HOT;
          ctx.fillText(p.text, p.x, p.y);
          ctx.globalAlpha = 1;
        });

        // bunkers
        ctx.fillStyle = "#C98A00";
        g.bunkers.forEach(bk => {
          for (let r = 0; r < bk.cells.length; r++) {
            for (let c = 0; c < bk.cells[r].length; c++) {
              if (bk.cells[r][c]) {
                ctx.fillRect(bk.x + c * BUNKER_PX, bk.y + r * BUNKER_PX, BUNKER_PX, BUNKER_PX);
              }
            }
          }
        });

        // ship (blink when invulnerable)
        if (g.invulnerable <= 0 || Math.floor(now / 100) % 2 === 0) {
          drawSprite(ctx, SHIP, g.ship.x - 22, g.ship.y - 12, 4, AMBER_HOT);
        }

        ctx.fillStyle = AMBER_HOT;
        g.bullets.forEach(b => ctx.fillRect(b.x - 2, b.y - 8, 4, 12));
        ctx.fillStyle = AMBER;
        g.bombs.forEach(b => {
          ctx.fillRect(b.x - 2, b.y - 6, 4, 6);
          ctx.fillRect(b.x - 4, b.y - 2, 8, 4);
        });
        g.particles.forEach(p => {
          ctx.globalAlpha = Math.max(0, p.life / 0.45);
          ctx.fillRect(p.x, p.y, 3, 3);
          ctx.globalAlpha = 1;
        });

        // hit flash
        if (g.flash > 0) {
          g.flash -= dt;
          ctx.fillStyle = `rgba(255,60,0,${g.flash})`;
          ctx.fillRect(0, 0, W, H);
        }

        // ground line
        ctx.fillStyle = AMBER_DIM;
        ctx.fillRect(0, H - 14, W, 2);
      }

      // CRT scanlines + vignette (always on — the signature)
      ctx.fillStyle = "rgba(0,0,0,0.18)";
      for (let y = 0; y < H; y += 3) ctx.fillRect(0, y, W, 1);
      const grad = ctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.35, W / 2, H / 2, Math.max(W, H) * 0.75);
      grad.addColorStop(0, "rgba(0,0,0,0)");
      grad.addColorStop(1, "rgba(0,0,0,0.55)");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, W, H);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  const amber = "#FFB000";
  const mono = "'Courier New', ui-monospace, monospace";

  return (
    <div style={{
      position: "fixed", inset: 0, background: "#050200",
      display: "flex", flexDirection: "column",
      fontFamily: mono, color: amber, userSelect: "none",
      WebkitUserSelect: "none", touchAction: "none", overflow: "hidden",
    }}>
      {/* HUD */}
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "10px 16px", fontSize: 13, letterSpacing: 2,
        textShadow: `0 0 8px ${amber}`, borderBottom: "1px solid #3a2600",
      }}>
        <span>SCORE {String(hud.score).padStart(5, "0")}</span>
        <span>WAVE {hud.wave}</span>
        <span>{"\u25B2".repeat(Math.max(0, hud.lives))}{" "}HI {String(hud.hi).padStart(5, "0")}</span>
      </div>

      {/* Play area */}
      <div ref={wrapRef} style={{ position: "relative", flex: 1 }}>
        <canvas ref={canvasRef} style={{ display: "block", cursor: "crosshair" }} />

        {screen !== "play" && (
          <div style={{
            position: "absolute", inset: 0, display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center", gap: 18,
            background: "rgba(5,2,0,0.82)", textAlign: "center", padding: 24,
          }}>
            <div style={{ fontSize: 30, letterSpacing: 6, textShadow: `0 0 16px ${amber}` }}>
              {screen === "start" ? "INVADERS" : "GAME OVER"}
            </div>
            {screen === "over" && (
              <div style={{ fontSize: 14, letterSpacing: 2, opacity: 0.9 }}>
                FINAL SCORE {String(hud.score).padStart(5, "0")}
                {hud.score >= hud.hi && hud.score > 0 ? " \u2014 NEW HIGH" : ""}
              </div>
            )}
            <div style={{ fontSize: 12, letterSpacing: 1.5, opacity: 0.7, lineHeight: 1.8 }}>
              DRAG TO MOVE &middot; SHIP FIRES AUTOMATICALLY<br />
              (KEYBOARD: ARROW KEYS)
            </div>
            <button
              onClick={start}
              style={{
                marginTop: 6, padding: "14px 38px", fontSize: 16, letterSpacing: 4,
                fontFamily: mono, color: "#050200", background: amber,
                border: "none", borderRadius: 2, cursor: "pointer",
                boxShadow: `0 0 20px rgba(255,176,0,0.6)`,
              }}
            >
              {screen === "start" ? "INSERT COIN" : "PLAY AGAIN"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
